<template>
  <div style="text-align: center">
    <div>
      <h2 class="mb-2">This shop doesn't exist.</h2>
    </div>
    <div>
      <img
        src="../../../assets/images/error.svg"
        width="150"
        class="mb4 mt-4"
      />
    </div>
    <div style="margin-top: 20px">
      <p>
        Double check the link that was shared with you and try again.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>
